<template lang="html">
  <Tabs :activeTab='activeTab' :tabs='["Step 1"].concat(uploadedDataRows.length ? "Step 2" : [])'>
    <div slot="t-1">
      <p>Upload Extensions rates files.</p>
      <div class="progress">
        <div class="progress-bar" role="progressbar" style="width: 33%" aria-valuenow="33" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <vue-dropzone ref="myVueDropzone" id="dropzone"
      :options="dropzoneOptions" @vdropzone-success='onUploadSuccess'
       @vdropzone-files-added='onFilesAdded'
       />
       <div class="dropzone-bottom">
         <div class="">
           <button type="button" :disabled='!succeededFilesAmount'
            class="btn btn-danger" name="button" @click='removeAllFiles'>
              Remove all
           </button>
           <button type="button" :disabled='!succeededFilesAmount'
            class="btn btn-primary" name="button" @click='activeTab = 1'>
              Continue
           </button>
         </div>
         <div class="">
           <a v-if='templateFile' class="btn btn-light template-download-link" :href='getTemplateUrl(templateFile)'
            target="_self" download>
            <i class="fa fa-file-excel-o"></i>
            Template
          </a>
        </div>
       </div>
    </div>
    <div slot="t-2">
      <p>
        Check the incoming changes that are about to be submitted.
      </p>
      <div class="progress">
        <div class="progress-bar" role="progressbar" style="width: 66%" aria-valuenow="66" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div>
        <Table
          :data='uploadedDataRows'
          :fields='_fields'
         />
         <button type="button"
          class="btn btn-link" name="button" @click='activeTab = 0'>
            Go Back
         </button>
         <button type="button" class="btn btn-success" @click='uploadFinal'>Upload Rates & Factors</button>
      </div>
    </div>
  </Tabs>
</template>

<script>

import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'

export default {
  props: {
    'api-url': {
      required: true,
      type: String
    },
    fields: {},
    templateFiles: {
      Type: Array
    },
    templateFile: {
      Type: String
    }
  },
  components: { vueDropzone },
  data() {
    return {
      dropzoneOptions: {
          url: null,
          thumbnailWidth: 150,
          maxFilesize: 0.5,
          acceptedFiles: '.csv'
        },
      uploadedData: [],
      uploadedFilesAmount: 0,
      succeededFilesAmount: 0,
      activeTab: 0
      }
    },
  created() {
    this.dropzoneOptions.url = this.$http.options.root + this.apiUrl + '/upload'
  },
  computed: {
    stage1Success() {
      return this.uploadedFilesAmount === this.succeededFilesAmount
    },
    _fields() {
      let fields = {...this.fields}
      ;['row_created_on'].forEach(v => {if(fields[v]) { delete fields[v] }})
      return fields
    },
    uploadedDataRows() {
      return Array.prototype.concat.apply([],this.uploadedData.map(e=>e.data))
    }
  },
  methods: {
    getTemplateUrl(fileName) {
      let apiUrl = this.apiUrl
      if(apiUrl.indexOf('app/') === 0) {
        apiUrl = apiUrl.substr('app/'.length)
      }
      let templateUrl = apiUrl.split('/')
      templateUrl.push('files', (fileName || templateUrl[templateUrl.length - 1]) + '.csv')
      templateUrl[0] = this.$options.filters.cap(templateUrl[0])
      templateUrl[1] = this.$options.filters.cap(templateUrl[1])
      templateUrl = this.$http.options.root + templateUrl.join('/')
      return templateUrl
    },
    onUploadSuccess(val, {data:{data}}) {
      this.uploadedData.push({name: val.name, data: data})
      this.succeededFilesAmount++
    },
    onFilesAdded(files) {
      this.uploadedFilesAmount += files.length
    },
    uploadFinal() {
      this.$http.post(this.apiUrl + '/save', {data: this.uploadedDataRows})
        .then(() => {})
        .catch(err => {})
    },
    removeAllFiles() {
      this.$refs.myVueDropzone.removeAllFiles(true)
      this.uploadedData.length = 0
      this.uploadedData = [] // to alert watch
    }
  }
}
</script>

<style lang="css" scoped>
.progress {
  margin-bottom: 10px;
}
.dropzone-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 11px;
}
.template-download-link {
  margin-right: 5px;
}
.progress {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/BatchUploader.vue